import React from 'react'

function Legal() {
  return (
    <div>Legal</div>
  )
}

export default Legal